export const parseTimeRange = (timeRange: string | null) => {
  if (!timeRange) return { open: "", close: "" };
  if (timeRange === "Closed") return "Closed";
  const [open, close] = timeRange.split("-");
  return {
    open: convertTo24Hour(open.trim()),
    close: convertTo24Hour(close.trim()),
  };
};

export const convertTo24Hour = (time: string) => {
  const match = time.match(/(\d+):(\d+)([ap]m)/i);
  if (!match) return "";

  const [, hours, minutes, period] = match;
  let hour = parseInt(hours);

  if (period.toLowerCase() === "pm" && hour < 12) hour += 12;
  if (period.toLowerCase() === "am" && hour === 12) hour = 0;

  return `${hour.toString().padStart(2, "0")}:${minutes}`;
};

export const formatTimeRange = (open: string, close: string) => {
  if (!open || !close) return "";
  return `${convertTo12Hour(open)}-${convertTo12Hour(close)}`;
};

export const convertTo12Hour = (time: string) => {
  const [hours, minutes] = time.split(":");
  let hour = parseInt(hours);
  const period = hour >= 12 ? "pm" : "am";

  if (hour > 12) hour -= 12;
  if (hour === 0) hour = 12;

  return `${hour}:${minutes}${period}`;
};
